import { bindActionCreators, Dispatch } from 'redux';
import { connect, RootStateOrAny } from 'react-redux';
import { useLocation } from "react-router";

import { Form, Modal, Rate, Skeleton } from "antd";
import TextArea from "antd/lib/input/TextArea";

import { useSessionStorage } from "utils/hooks";
import notifier from "utils/notifier";
import { ErrorResponse } from "utils/types";

import { sendFeedback } from 'store/app/actions';

import { SurveyModalProps } from "./Proptypes";

const SurveyModal = ({ sendFeedback, isSendingFeedback, setVisible, ...rest }: SurveyModalProps) => {

  const [form] = Form.useForm();
  const [surveyed, setSurveyed] = useSessionStorage('surveyed', false);
  const location = useLocation();

  const goToLegacy = (values: any) => {
    let formObject = {
      CompanyId: sessionStorage.getItem('ipaGroup'),
      Rating: values.rating,
      Feedback: values.feedback,
      UserId: sessionStorage.getItem('user_id'),
      Location: location.pathname,
      CreatedBy: sessionStorage.getItem('user_id'),
    };
    
    window.open('https://www.networkmedicalmanagement.com/providers/provider-portal', '_blank');

    return sendFeedback(formObject)
      .then((response: boolean) => {
        if (response) {
          notifier.success('Thank you for your help!', 'We will contact you regarding this issue as soon as possible.');
        }
        setVisible(false);
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
        setVisible(false);
      });
  };

  const onSubmit = () => {
    form.validateFields().then(values => {
      setSurveyed(true);
      goToLegacy(values);
      form.resetFields();
    })
  };

  return (
    <Modal
      {...rest}
      title={isSendingFeedback ? 'Sending Feedback...' : 'Before you go...'}
      onOk={onSubmit}
      okText={'Switch'}
      onCancel={() => setVisible(false)}
      cancelText={'Go Back'}
      maskClosable={false}
      width={'600px'}
      closable={false}
      okButtonProps={{ loading: isSendingFeedback }}
    >
      {isSendingFeedback ?
        <Skeleton 
          active
          paragraph={{ rows: 4 }}
          avatar
        />
        :
        <Form 
          form={form} 
          name={'feedbackSurvey'} 
          onFinish={onSubmit}
        >
          <Form.Item
            name="rating"
            label="How was your experience?"
            labelCol={{ span: 36 }}
            rules={[
              { required: !surveyed, message :'Required once per browser session.' }
            ]}
          >
            <Rate allowHalf style={{ fontSize: 40 }} />
          </Form.Item>
          <Form.Item
            name="feedback"
            label="How can we do better?"
            labelCol={{ span: 24 }}
            rules={[
              { required: !surveyed, message :'Required once per browser session.' },
              () => ({
                async validator(_: any, value: any) {
                  if (!value || value.length > 4) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('Please enter at least 5 characters.'));
                },
              })
            ]}
          >
            <TextArea rows={4} />
          </Form.Item>
        </Form>
    }
      
    </Modal>
  );
};

const mapStateToProps = (state: RootStateOrAny) => ({
  isSendingFeedback: state.rootReducer.app.isSendingFeedback,
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
  {
    sendFeedback,
  },
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(SurveyModal);